module.exports = __webpack_public_path__ + "media/CGM2.fd854e09.mp4";